import LoginPage from '../pages/LoginPage';
import MobileAuthWrapper from '../pages/MobileAuthWrapper';

export default function MobileLogin() {

  return (
    <MobileAuthWrapper>
      <LoginPage />
    </MobileAuthWrapper>
  );
}